import { z } from 'zod';
import { Paginated } from '../../common/pagination.js';
import { AdminActionInput } from '../shared.js';
import { SanctionView } from '../moderation/schemas.js';
import { MemberActivity, MemberAdminView, MemberDeletionView, MemberSearchQuery, } from './schemas.js';
export const adminMembersRoutes = {
    members: {
        method: 'GET',
        path: '/admin/members',
        query: MemberSearchQuery,
        response: Paginated(MemberAdminView),
    },
    member: { method: 'GET', path: '/admin/members/:userId', response: MemberAdminView },
    memberActivity: {
        method: 'GET',
        path: '/admin/members/:userId/activity',
        response: MemberActivity,
    },
    /** Data export on request (FR-ADM-44, NFR-08). Audited. */
    memberExport: {
        method: 'POST',
        path: '/admin/members/:userId/export',
        body: AdminActionInput,
        response: z.object({
            userId: z.string(),
            exportedAt: z.coerce.date(),
            data: z.record(z.string(), z.unknown()),
        }),
    },
    suspendMember: {
        method: 'POST',
        path: '/admin/members/:userId/suspend',
        body: AdminActionInput.extend({ days: z.number().int().min(1).max(365) }),
        response: SanctionView,
    },
    reinstateMember: {
        method: 'POST',
        path: '/admin/members/:userId/reinstate',
        body: AdminActionInput,
        response: SanctionView,
    },
    /**
     * Close a member account (FR-ADM-41), honouring NFR-08 / AC-ADM-30.4.
     *
     * A SOFT delete, and deliberately so. Nothing is removed from any
     * collection: the account is tombstoned, sign-in stops working, and the
     * member stops being visible to other members. Payments, donations and
     * political-contribution records therefore survive untouched, which NFR-08
     * requires and `Q-28` — the retention period, still unanswered — makes it
     * impossible to do correctly any other way. Physical erasure is a separate
     * job for whenever that question is settled; deciding it here, in an
     * endpoint, would be guessing at law.
     *
     * The member's identifiers stay ON the tombstone rather than being released.
     * This is an admin closing an account, not a member exercising erasure: if
     * the email and phone were freed, the account an admin just closed could be
     * re-registered from the same address minutes later, which defeats the
     * point of closing it.
     */
    deleteMember: {
        method: 'POST',
        path: '/admin/members/:userId/delete',
        body: AdminActionInput,
        response: MemberDeletionView,
    },
    /** Undo the above. Exact, because the delete destroyed nothing (AC-ADM-30.3). */
    restoreMember: {
        method: 'POST',
        path: '/admin/members/:userId/restore',
        body: AdminActionInput,
        response: MemberDeletionView,
    },
};
//# sourceMappingURL=routes.js.map